import { render, staticRenderFns } from "./BudgetInput.vue?vue&type=template&id=3183213d&scoped=true&"
import script from "./BudgetInput.vue?vue&type=script&lang=js&"
export * from "./BudgetInput.vue?vue&type=script&lang=js&"
import style0 from "./BudgetInput.vue?vue&type=style&index=0&id=3183213d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3183213d",
  null
  
)

export default component.exports